(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proplay-ask-chris"] && !Shopify.designMode) return;
  try {
    
const ppModel=document.querySelector('[data-model]');if(ppModel){const ppParams=new URLSearchParams(location.search);ppModel.value=(ppParams.get('model')||'').slice(0,200);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proplay-page-tools"] && !Shopify.designMode) return;
  try {
    
function setupProPlayBatFinder(root){root.querySelectorAll('.pp-bf').forEach(finder=>{
 if(finder.dataset.ready)return;finder.dataset.ready='true';const form=finder.querySelector('form');const cards=Array.from(finder.querySelectorAll('.pp-bf-card'));const prepared=cards.map(card=>({card,variants:JSON.parse(card.querySelector('.pp-bf-variants').textContent).map(v=>{const length=v.title.match(/(\d+)\s*in(?:ch)?/i);return {...v,length:length?length[1]:'unknown',drop:card.dataset.material==='wood'?v.title.trim():card.dataset.drop};})}));
 const update=()=>{const val=name=>form.elements.namedItem(name).value;const stock=form.elements.stock.checked;let shown=0;prepared.forEach(({card,variants})=>{const matching=variants.filter(v=>(!stock||v.available)&&(!val('length')||v.length===val('length'))&&(!val('drop')||v.drop===val('drop')));const show=(!val('material')||card.dataset.material===val('material'))&&(!val('use')||card.dataset.use.split(' ').includes(val('use')))&&(!val('cert')||card.dataset.cert===val('cert'))&&matching.length>0;card.hidden=!show;if(show){shown++;card.querySelector('.pp-bf-match').textContent=matching.filter(v=>v.available).length+' available matching option(s)';const variant=matching.find(v=>v.available)||matching[0];card.querySelector('.pp-bf-action').href=card.querySelector('h3 a').getAttribute('href')+'?variant='+variant.id;}});finder.querySelector('.pp-bf-count').textContent=shown+' matching bat'+(shown===1?'':'s');finder.querySelector('.pp-bf-empty').hidden=shown!==0;};
 form.addEventListener('change',update);form.addEventListener('reset',()=>requestAnimationFrame(update));update();});}
setupProPlayBatFinder(document);document.addEventListener('shopify:section:load',event=>setupProPlayBatFinder(event.target));

  } catch(e) { console.error(e); }
})();
})();
